import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'next-i18next';

import { FormLabelWrapper, TextInput } from '@restworld/ui-ds-base';

import { useWizardLastStepInputs } from '../../worker-application-wizard.constants';
import { WizardStepProps } from '../../worker-application-wizard.types';
import { useWorkerApplicationCxt } from '../../worker-application-wizard.context';
import { HelperTextRElement } from '../form-inputs';

export const WizardFourteenStep: React.FunctionComponent<WizardStepProps> = (props) => {
  const { errorsTextMap } = useWorkerApplicationCxt();
  const { control } = useFormContext();
  const wizardLastStepInputs = useWizardLastStepInputs();
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-4">
      {wizardLastStepInputs?.map(({ key, rules, title, type, placeholder }) => {
        const helperText = errorsTextMap[key];
        const helperTextEl = <HelperTextRElement helperText={errorsTextMap[key]} />;
        return (
          <FormLabelWrapper key={key} id={key} label={title}>
            <Controller
              name={key}
              control={control}
              rules={{
                ...rules,
                pattern: {
                  value: /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/,
                  message: t('onboarding-page:enter_valid_url'),
                },
              }}
              render={({ field }) => (
                <TextInput
                  id={key}
                  placeholder={placeholder}
                  type={type}
                  helperText={helperTextEl}
                  color={helperText ? 'failure' : undefined}
                  testId={`${title}-link-input`}
                  {...field}
                />
              )}
            />
          </FormLabelWrapper>
        );
      })}
    </div>
  );
};
export default WizardFourteenStep;
